import * as Actions from '../actions/marketplace.actions';

const initialState = {
	list: [],
	loaded: false,
	loading: false,
	stack: null,
	logs: null,
	error: null
};

const marketplaceReducer = (state = initialState, action) => {
	
	switch (action.type) {
		case Actions.SET_MARKETPLACE_LOADING: {
			return {
				...state,
				loading: true
			};
		}
		case Actions.SET_MARKET_STACKS_LIST: {
			return {
				...state,
				list: action.payload,
				loaded: true,
				loading: false
			};
		}
		case Actions.SET_STACK: {
			return {
				...state,
				stack: action.payload
			};
		}
		case Actions.SET_FILTER: {
			return {
				...state,
				filter: action.payload
			};
		}
		case Actions.SET_LOGS: {
			return {
				...state,
				logs: action.payload
			};
		}
		case Actions.SET_MARKETPLACE_ERROR: {
			return {
				...state,
				error: action.payload,
				loading: false
			};
		}
		case Actions.CLEAR_STACK: {
			return {
				...state,
				stack: null
			};
		}
		case Actions.CLEAR_ERROR: {
			return {
				...state,
				error: null
			};
		}
		case Actions.CLEAR_LOGS: {
			return {
				...state,
				logs: null
			};
		}
		default: {
			return state;
		}
	}
};

export default marketplaceReducer;
